<template>
  <div class="container-fluid mt--12">
    <actions-declaracao-inss/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <grafico-declaracao-inss/>
      </div>
    </div>
  </div>
</template>

<script>
import DeclaracaoInssGraficoDetalhado from "./DeclaracaoInssGraficoDetalhado";
import DeclaracaoInssActions from "./DeclaracaoInssActions";
export default {
  name: "DeclaracaoInssContainerGrafico",
  components: {
    "grafico-declaracao-inss": DeclaracaoInssGraficoDetalhado,
    "actions-declaracao-inss": DeclaracaoInssActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssContainerGrafico.vue